export default {
  MAIL: "mail",
  VISIT: "visit",
  ESTABLISHMENT: "establishment",
};
